import configs from '../config/config';

export const haveSameElements = (ia, ib) => {
  if (ia.length !== ib.length) return false;
  const a = ia.slice().sort();
  const b = ib.slice().sort();
  let isSame = true;
  for (let i = 0, l = a.length; i < l; i += 1) {
    if (a[i] !== b[i]) {
      isSame = false;
      break;
    }
  }
  return isSame;
}

export const customSortingByOrder = (arr, order, field) => {
  return [...arr].sort((a,b) => (order === 'asc') ? a[field] - b[field] : b[field] - a[field]);
}

export const balanceSummary = (list) => {
  let s = 0;
  list.forEach(item => s += item.wallets[0].balance);
  return customParseFloat(s);
}

export const customParseFloat = (number) => {
  return parseFloat(parseFloat(number).toFixed(2));
  // number = parseFloat(number, 10);
  // if(number) number = (number ^ 0) === number ? number : number.toFixed(2);
  // return number;
}